import cleanedFilename from '~/util/cleanedFilename';

export default {
  DESCRIPTION: `${cleanedFilename(__filename)}-description`,
  DELETE_BUTTON: `${cleanedFilename(__filename)}-delete-button`,
  CONTAINER: `${cleanedFilename(__filename)}-container`,
};
